import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Remix.svg'

export const IconRemix = IconSVG as IconComponent
